import type { IPaginationRequest } from 'types/pagination.types';
import db from './db';

type Params = Partial<IPaginationRequest> & {
  text?: string;
};

type FontWeights = '400' | '500' | '600' | '700' | '800';

export type FontOptionType = {
  label: string;
  value: string;
  installName: string;
  preview: string;
  weights: Partial<Record<FontWeights, string>>;
};

const defaultParams = {
  perPage: 15,
  page: 1,
};

export const getFontsOptions = (params?: Params) => {
  const { perPage, page } = { ...defaultParams, ...params };
  const start = (page - 1) * perPage;
  const end = start + perPage;
  const text = params?.text?.toLowerCase().trim();

  const fonts = text
    ? db.filter((font) => font.label.toLowerCase().includes(text))
    : db;

  const data = fonts.slice(start, end);

  return Promise.resolve({
    data,
    paging: {
      page,
      perPage,
      pageCount: data.length,
      pagesCount: Math.ceil(fonts.length / perPage),
      totalCount: fonts.length,
    },
  });
};

export const getFontOptionSync = (
  family?: string,
): FontOptionType | undefined => {
  if (!family) return;
  return db.find((font) => font.value.toLowerCase() === family.toLowerCase());
};
